(function ($, Drupal) {
  ('use strict');

  // CPT Announcement banner
  $('.cpt-announcement-banner .btn-announcement-close').on('click', function (e) {
      e.preventDefault();
      $(this).parents('.cpt-announcement-banner').fadeOut('slow');
    },
  );

  // Fix tooltip overlap/underlap issue
  $('.webform-options-display-buttons-wrapper').on('mouseenter', function (e) {
    $(this).addClass('hovered');
  });
  $('.webform-options-display-buttons-wrapper').on('mouseleave', function (e) {
    $(this).removeClass('hovered');
  });

  // Mobile menu toggle
  $('.btn-menu-toggle').on('click', function (e) {
    e.preventDefault();
    $('.master-template-header').toggleClass('menu-open');
    $('body').toggleClass('menu-open');
  });

  // Main menu first level dropdowns
  if (!($('body').hasClass('supported-living-theme') || $('body').hasClass('beech-grove-theme') || $('body').hasClass('homes-theme') || $('body').hasClass('keyworker-theme'))) {
    $('.menu-item-dropdown .main-menu-top-btn').attr('aria-expanded', 'false');
    $('.menu-item-dropdown .main-menu-top-btn').on('click', function (e) {
      e.preventDefault();
      $('.sub-menu-wrap').css('min-height', '0');
      if ($(this).parent().hasClass('main-dropdown-open')) {
        $('.menu-item-dropdown').removeClass('main-dropdown-open');
        $('.menu-item-dropdown button').attr('aria-expanded', 'false');
      } else {
        $('.menu-item-dropdown').removeClass('main-dropdown-open');
        $('.menu-item-dropdown button').attr('aria-expanded', 'false');
        $(this).parent().addClass('main-dropdown-open');
        $(this).attr('aria-expanded', 'true');

        var subMinHeight = $('.sub-dropdown-open .sub-sub-menu').outerHeight();
        $('.sub-menu-wrap').css('min-height', subMinHeight + 'px');
      }
    });

    $('.menu-item-dropdown.sub-item > button').attr('aria-expanded', 'false');
    $('.menu-item-dropdown.sub-item > button').on('click', function (e) {
      e.preventDefault();
      $('.sub-menu-wrap').css('min-height', '0');
      $('.sub-sub-menu').css('min-height', '0');
      if ($(this).parent().hasClass('sub-dropdown-open')) {
        $('.menu-item-dropdown').removeClass('sub-dropdown-open');
        $('.menu-item-dropdown button').attr('aria-expanded', 'false');
      } else {
        $('body').addClass('sub-sub-open');
        $('.menu-item-dropdown').removeClass('sub-dropdown-open');
        $('.menu-item-dropdown button').attr('aria-expanded', 'false');
        $(this).parent().addClass('sub-dropdown-open');
        $(this).attr('aria-expanded', 'true');

        var subMinHeight = $('.sub-dropdown-open .sub-sub-menu').outerHeight();
        var subSubMinHeight = $('.main-dropdown-open .sub-menu').outerHeight();
        $('.sub-menu-wrap').css('min-height', subMinHeight + 'px');
        $('.sub-dropdown-open .sub-sub-menu').css('min-height', (subSubMinHeight) + 'px');
      }
    });

    $('.btn-sub-sub-back').on('click', function (e) {
      e.preventDefault();
      $(this).closest('.sub-item').removeClass('sub-dropdown-open');
      $('body').removeClass('sub-sub-open');
    });
  }

  // Top nav dropdown
  $('.top-nav-wrap .menu-item button').on('click', function (e) {
    e.preventDefault();
    if ($(this).parent().hasClass('top-dropdown-open')) {
      $('.top-nav-wrap .menu-item').removeClass('top-dropdown-open');
      $('.top-nav-wrap .menu-item button').attr('aria-expanded', 'false');
    } else {
      $('.top-nav-wrap .menu-item').removeClass('top-dropdown-open');
      $('.top-nav-wrap .menu-item button').attr('aria-expanded', 'false');
      $(this).parent().addClass('top-dropdown-open');
      $(this).attr('aria-expanded', 'true');
    }
  });

  $('.master-template-breadcrumb, .master-template-content').on('click', function (e) {
    $('.master-template-header').removeClass('menu-open');
    $('.menu-item-dropdown').removeClass('main-dropdown-open sub-dropdown-open');
    $('.menu-item-dropdown .main-menu-top-btn').attr('aria-expanded', 'false');
    $('.menu-item-dropdown.sub-item > button').attr('aria-expanded', 'false');
    $('.top-nav-wrap .menu-item').removeClass('top-dropdown-open');
    $('.top-nav-wrap .menu-item').attr('aria-expanded', 'false');
    $('body').removeClass('sub-sub-open');
  });

  Drupal.behaviors.collapsibleToggles = {
    attach: function attach(context, settings) {
      // Generic toggle
      $(once('collapsible-toggle-on', '.item-collapsible .btn-toggle', context)).click(function (e) {
        e.preventDefault();
        $(this).closest('.item-collapsible').toggleClass('item-collapsible-open');
        $(this).toggleAttrVal('aria-expanded', 'true', 'false');
      });
      $(once('announcement-toggle-off', '.btn-announcement-close', context)).click(function () {
        $('.item-collapsible button.btn-toggle').unbind('click');
      });

      // Close generic toggle on clicking away
      $(once('collapsible-toggle-off', '.master-template-breadcrumb, .master-template-content', context)).click(function (e) {
        if (!$(e.target).closest('.item-collapsible').length) {
          $('.item-collapsible').removeClass('item-collapsible-open');
          $('.item-collapsible .btn-toggle').attr('aria-expanded', 'false');
        }
      });
    },
  };

  // Tooltip
  $('.btn-info').on('click', function (e) {
    e.preventDefault();
    if ($(this).parent().next().hasClass('tooltip-open')) {
      $('.tooltip').removeClass('tooltip-open');
      $('.btn-info').attr('aria-expanded', 'false');
    } else {
      $('.tooltip').removeClass('tooltip-open');
      $(this).parent().next('.tooltip').addClass('tooltip-open');
      $(this).attr('aria-expanded', 'true');
    }
  });

  $('.btn-close').on('click', function (e) {
    e.preventDefault();
    $('.tooltip').removeClass('tooltip-open');
    $('.btn-info').attr('aria-expanded', 'false');
  });

  // Toggle Attribute
  $.fn.toggleAttr = function (attr, val) {
    var test = $(this).attr(attr);
    if (test) {
      $(this).removeAttr(attr);
    } else {
      $(this).attr(attr, val);
    }
    return this;
  };

  $.fn.toggleAttrVal = function (attr, val1, val2) {
    var test = $(this).attr(attr);
    if (test === val1) {
      $(this).attr(attr, val2);
      return this;
    }
    if (test === val2) {
      $(this).attr(attr, val1);
      return this;
    }

    $(this).attr(attr, val1);
    return this;
  };

  // Hide News Sidebar
  $('.page-node-type-news .coh-col-xl-4 > div:empty').parent().hide();

  // Responsive Tables
  $.fn.fluidTable = function () {
    $(this).each(function () {
      var $element = $(this),
        headertext = [],
        $headers = [];
      $headers = $element.find('th');

      // Table without a main header row
      if ($element.find('thead th').length === 0) {
        $headers = $headers.slice(0, 0);
        $element.addClass('no-row-headers');
        // Table with a header column as well as a header row.
      } else if ($element.find('tbody tr th').length > 0) {
        // Remove the corner header
        $headers = $headers.slice(1);
      }

      $element.addClass('fluid-table');

      $headers.each(function () {
        headertext.push($(this).text().replace(/\r?\n|\r/, ''));
      });

      if ($headers.length > 0) {
        $element.find('tr').each(function () {
          $(this).find('td').each(function (a) {
            $(this).attr('data-th', headertext[a]);
          });
        });
      }
    });
  };

  // Force tables to be responsive
  $('.coh-wysiwyg table, .developments-table-wrapper table').fluidTable();

  // Go Button
  if ($('.go-banner').length) {
    $('body').addClass('quick-exit-button')
    $('.go-banner .coh-link').attr('tabindex', '1');
    $('.skip-link').attr('tabindex', '2');
    $(".master-template-footer").css('paddingBottom', ($(".go-banner").innerHeight() - 1));
  }

  var goUrl = $('.go-banner .coh-link').attr('href')

  function getAway(url) {
    // Get away right now
    window.open(url, '_newtab');
    // Replace current site with another benign site
    window.location.replace('http://google.com');
  }

  $('.go-banner').on('click', function() {
    getAway(goUrl);
  });

  $('.go-banner .coh-link').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    getAway(goUrl);
  });

  // Search Focus trap

  $('#edit-keywords').on('keydown', function(e) {
    var keyCode = e.keyCode || e.which; 

    if (keyCode === 9 && e.shiftKey) {
      e.preventDefault(); 
      $('.spb_close').focus();
    } 
  });


})(jQuery, Drupal);
